module.exports = __webpack_public_path__ + "static/media/immersive-ai.c61e4fc2.png";